/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
import React, { useState } from 'react';
import "../pageLayout.css";
import { useAuth } from '../AuthProvider';
import Signup from './Signup';
/**
 * Renders the navbar component with a sign-in or sign-out button depending on whether or not a user is authenticated
 * @param props
 */
export const PageLayout = () => {
  const { user, loading, login, logout } = useAuth();
  const [showSignup, setShowSignup] = useState(false);

  if (loading) {
    return (
      <div className="login-view-container">
        <div className="login-card">
          <h1 className="title">Loading...</h1>
        </div>
      </div>
    );
  }

  return (
    <div className="login-view-container">
      <div className="login-card">
        {showSignup ? (
          <Signup onCancel={() => setShowSignup(false)} />
        ) : (
          <>
            <h1 className="title">Race Results Live <br/>Early Access</h1>

            <div className="beta-message">
              <p>You're among the first to run this - thanks for being part of it.</p>
              <p>This is an early access build, so it may not be perfect yet.</p>
              <p>
                If something looks off, or just feels wrong - tell us at{" "}
                <a href="mailto:feedback@1320cc.com">feedback@1320cc.com</a>.
              </p>
              <p>Got ideas to make it better? We want those too.</p>
              <p>Your feedback helps us tune this like a race car.</p>
              <p><strong>Thanks for helping us get it right.</strong></p>
            </div>
            <p className="subtitle">Sign in to access Race Results</p>

            {user ? (
              <button
                className="login-search-button logout"
                onClick={() => logout()}
              >
                Sign Out
              </button>
            ) : (
              <div className="button-group">
                <button className="login-search-button login" onClick={() => login()}>
                  Sign In
                </button>
                <button className="login-search-button signup" onClick={() => setShowSignup(true)}>
                  Sign Up
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};
